import styled from 'styled-components';
import { Modal, Typography } from 'antd';

const { Title } = Typography;

export const TextTitle = styled(Title)`
    font-size: 16px !important;
    margin: 0 !important;
    color: ${({ theme }) =>
        theme.theme === 'dark' ? '#fff' : '#262626'} !important;
    font-weight: 500 !important;
`;

export const ContentTitle = styled.div`
    padding: 17px 25px;
    border-bottom: 1px solid
        ${({ theme }) =>
            theme.theme === 'dark' ? theme.colors.antdBorder : '#f0f0f0'};
`;

export const StyledModal = styled(Modal)`
    .ant-modal-footer {
        z-index: 99999;
        position: relative;
        background: ${({ theme }) =>
            theme.theme === 'dark' ? theme.colors.colorBgElevated : '#fff'};
    }
    .ant-modal-content {
        overflow: hidden;
    }
`;

export const StepContent = styled.div<{ hidden?: boolean }>`
    display: ${(props) => (props.hidden ? 'none' : 'block')};
`;

export const ConfirmTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.antdText};
`;

export const OverwriteWarning = styled.div`
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 4px;
    border-left: 4px solid #faad14;
    background: ${({ theme }) =>
        theme.theme === 'dark' ? '#2a2412' : '#fffbe6'};

    p {
        margin: 6px 0 12px;
        color: ${({ theme }) => theme.colors.antdText};
    }
`;

export const OverwriteWarningHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.antdText};

    svg {
        flex-shrink: 0;
        color: #faad14;
    }
`;

export const OverwriteList = styled.div`
    max-height: 168px;
    overflow-y: auto;
`;

export const OverwriteListItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 4px;
    color: ${({ theme }) => theme.colors.antdText};

    & + & {
        border-top: 1px solid
            ${({ theme }) =>
                theme.theme === 'dark'
                    ? 'rgba(255, 255, 255, 0.12)'
                    : '#f0e2b6'};
    }

    svg {
        flex-shrink: 0;
        color: #faad14;
    }
`;

export const ConfirmOverwriteRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
`;

export const ConfirmOverwriteLabel = styled.label`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.antdText} !important;
`;
